import {
  api_my_user_path, webauthn_initiate_api_my_user_path, webauthn_finalize_api_my_user_path
} from "../../routes";
import {get, patch} from "../http_client";

export const show = () => get({url: api_my_user_path()})
export const webauthn_initiate = () => get({url: webauthn_initiate_api_my_user_path()})
export const webauthn_finalize = (cred) => patch({
  url: webauthn_finalize_api_my_user_path(),
  params: {webauthn_credential: cred}
})